export const itemsPerPageOptions = [10, 25, 50, 100, 500];

export const initialPager = { page: 1, limit: 10 };
